import { SheetId, SheetReducerState, SheetState, SheetStateByKey } from './sheetTypes';

export const getSheetKey = (sheetId: SheetId, instanceId?: string) =>
    instanceId ? `${sheetId}-${instanceId}` : sheetId;

export const getSheetReducerState = (state: unknown): SheetReducerState =>
    (state as Immutable.Map<string, object>).getIn(['app', 'sheet']) as SheetReducerState;

export const getSheetsState = (state: unknown): SheetStateByKey => getSheetReducerState(state).sheets;

export const getSheetState =
    (sheetId: SheetId, instanceId?: string) =>
    (state: unknown): SheetStateByKey[SheetId] => {
        const sheetKey = getSheetKey(sheetId, instanceId);
        return getSheetsState(state)[sheetKey];
    };

export const getIsSheetOpen =
    (sheetId: SheetId, instanceId?: string) =>
    (state: unknown): boolean => {
        const sheetState = getSheetState(sheetId, instanceId)(state);
        return sheetState?.active ?? false;
    };

export const getIsAnySheetOpen = (state: unknown): boolean => {
    const sheetState = getSheetsState(state);
    return Object.values(sheetState).some((sheet) => sheet?.active);
};

/*
 * Returns true if any open sheet matches the provided filter
 */
export const getAnyMatchingSheetOpen =
    (filter: (sheetState: SheetState) => boolean) =>
    (state: unknown): boolean => {
        const sheetState = getSheetsState(state);
        return Object.values(sheetState).some((sheetState) => {
            if (!sheetState?.active) return false;

            return filter(sheetState);
        });
    };

export const getSheetActiveSnapPoint =
    (sheetId: SheetId, instanceId?: string) =>
    (state: unknown): number => {
        const sheetState = getSheetState(sheetId, instanceId)(state);
        return sheetState?.activeSnapPoint ?? 0;
    };

export const getSheetData =
    (sheetId: SheetId, instanceId?: string) =>
    (state: unknown): object | undefined => {
        const sheetState = getSheetState(sheetId, instanceId)(state);
        return sheetState?.data;
    };
